import { useFeatureFlagEnabled } from "posthog-js/react";

import { POSTHOG_FEATURE_FLAGS } from "context/posthog/featureFlags";

export function useMandatesFeatureFlag() {
  return useFeatureFlagEnabled(POSTHOG_FEATURE_FLAGS.enableMandates);
}
